import IconCoinsSolid from '@/assets/icons/font_awesome/coins-solid.svg?react';
import NotifierBorder from '@/components/ui/notifier/notifier-border';
import { EZIndexes } from '@/enums/EZIndexes';
import { HOOK_RESULT__notifier } from '@/hooks/HOOK__notifier';
import { forwardRef, useImperativeHandle, useRef, useState } from 'react';

interface Props {
  is_parent_hovered: boolean;
  className?: string;
  title: string;
  on_click: () => void;
  disabled?: boolean;
  notifier?: HOOK_RESULT__notifier;
  render_icon_credits?: boolean;
}

export const ButtonWithHoverAnimateBorder = forwardRef<HTMLDivElement, Props>(
  ({ is_parent_hovered, className = '', title, on_click, disabled = false, notifier, render_icon_credits = true }, ref) => {
    const [is_hovered, set_is_hovered] = useState(false);
    const ref_outer = useRef<HTMLDivElement>(null);

    // Expose the internal ref through the forwardRef
    useImperativeHandle(ref, () => ref_outer.current as HTMLDivElement);

    /*
     * RENDERS
     */

    function render_icon() {
      if (!render_icon_credits) return null;

      return <IconCoinsSolid className={`!size-2.5 ${is_parent_hovered && !disabled ? '!text-purchase' : '!text-component-item-selected'}`} />;
    }

    function render_button_animated() {
      const width = ref_outer.current?.clientWidth ?? 0;
      const height = ref_outer.current?.clientHeight ?? 0;

      return (
        <div ref={ref_outer} className={`rounded-md-for-gradient animation-gradient-purchase cursor-pointer flex items-center justify-center ${className}`}>
          <div
            style={{ width: width - 4, height: height - 4 }}
            className={`absolute ${EZIndexes.Z_2} flex items-center justify-center gap-1 bg-component rounded-md`}
          >
            <span className="gradient-text-theme-purchase font-bold text-sm">{title}</span>
            {render_icon()}
          </div>
        </div>
      );
    }

    function render_button() {
      return (
        <div
          ref={ref_outer}
          className={`flex items-center justify-center gap-1 bg-component border rounded-md ${className}
            ${disabled ? 'opacity-50 cursor-not-allowed' : ''}
            ${is_parent_hovered && !disabled ? 'border-purchase' : 'border-component-item-selected'}`}
        >
          <span className={`font-bold text-sm ${is_parent_hovered && !disabled ? 'text-purchase' : 'text-component-item-selected'}`}>{title}</span>
          {render_icon()}
        </div>
      );
    }

    function render_view() {
      if (is_parent_hovered && is_hovered && !disabled) return render_button_animated();

      return render_button();
    }

    /*
     * HTML
     */

    return (
      <div className={className} onMouseEnter={() => set_is_hovered(true)} onMouseLeave={() => set_is_hovered(false)} onClick={on_click}>
        {render_view()}
        {notifier && <NotifierBorder notifier={notifier} />}
      </div>
    );
  },
);

ButtonWithHoverAnimateBorder.displayName = 'ButtonWithHoverAnimateBorder';
